import { useRef, useEffect } from 'react';

import { filterQuery } from './filter-query';
import { getSortedQueryParams } from './get-sorted-query-params';
import { useRentCatalogQuery } from './use-rent-catalog-query';

export const useReturnToFirstPage = () => {
  const { query, setQuery } = useRentCatalogQuery();

  const prevFilteredQueryRef = useRef('');
  const isFirstRenderRef = useRef(true);

  const filteredQuery = getSortedQueryParams(
    query,
    (val: [keyof typeof query, (typeof query)[keyof typeof query]]) =>
      filterQuery(val, ['page'])
  );

  useEffect(() => {
    if (isFirstRenderRef.current) {
      isFirstRenderRef.current = false;
      prevFilteredQueryRef.current = filteredQuery;
      return;
    }

    if (prevFilteredQueryRef.current !== filteredQuery && query.page !== 1) {
      setQuery({ page: 1 }, { scroll: true });
    }

    prevFilteredQueryRef.current = filteredQuery;
  }, [filteredQuery, query.page, setQuery]);
};
